<template>
  <div class="content">
    <div class="f-b-c">
      <div class="nav-head">
        <p>商城导航由 “品类 + 导航菜单” 组成，此页面只设置导航菜单，若要修改品类，请到 <el-button type="text" @click="$router.push('/supply/category')">品类</el-button> 页面</p>
        <div>导航栏设置<span>最多设置十一个一级导航</span></div>
      </div>
      <div>
        <el-button type="primary" @click="addNav('add')">新增</el-button>
      </div>
    </div>

    <el-table v-loading="loading" :key="tableKey" :data="navList" ref="navTable" height="calc(100vh - 198px)"
      row-key="id"
      :tree-props="{ children: 'child' }"
      :expand-row-keys="expands"
      @expand-change="expandChange">
      <el-table-column width="150">
        <div slot-scope="{row}" class="sort-icon" :style="{left: `calc(${2 * row.level}0% - ${(row.level-1)*10}px)`}">
          <i class="iconfont icon-line-height a-icon" />
        </div>
      </el-table-column>
      <el-table-column label="导航名称"  min-width="110">
        <div slot-scope="{row}" class="f--c">
          <div>{{ row.name }}
            <img :src="row.labelImgUrl" alt="" style="height:18px">
          </div>
        </div>
      </el-table-column>
      <el-table-column label="导航图片" min-width="160">
        <template slot-scope="{row}">
          <img :src="row.imgUrl" alt="" style="height:40px">
        </template>
      </el-table-column>
      <el-table-column label="跳转链接" min-width="160">
        <div slot-scope="{row}" class="f--c">
          <el-tag v-if="row.status === 0" type="info" style="margin-right:10px">失效</el-tag>
          <el-button type="text" @click="openLink(row)" :disabled="!row.linkUrl">{{ row.linkName || row.linkUrl }}</el-button>
        </div>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="addNav('edit', row)">编辑</el-button>
          <el-button v-if="row.level<4" type="text" size="medium" @click="addNav('add', row)">添加子级</el-button>
          <el-button type="text" size="medium" @click="deleteNav(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- <div class="f-b-c bg-white" style="padding: 10px">
      <div></div>
      <el-pagination background layout="total,prev, pager, next" :current-page="listForm.pageNumber" :page-size="listForm.pageSize" :total="total" @current-change="pageChange"></el-pagination>
    </div> -->

    <Add ref="navDialog" @addSuccess="getCustomNavList()"></Add>
  </div>
</template>

<script>
import API from '@/api'
import { dateFormat } from '@/utils/date'
import Add from './components/add.vue'
// import Sortable from 'sortablejs'
import { createSortTable } from '@/views/js/treeSortable'

export default {
  name: 'operation_customNav',
  components: { Add },
  data() {
    return {
      loading: false,
      listForm: {
        pageNumber: 1,
        pageSize: 20,
      },
      navList: [],
      sortable: null, // sortable对象
      tiledTable: [], // 平铺table数据
      tableKey: '', // 刷新table
      expands: [], // 指定展开ids
      bodyWrapperScrollTop: 0 // 表格移动的位置
    }
  },
  created() {
    this.getCustomNavList()
  },
  mounted() {
  },
  methods: {
    // initSortTable() {
    //   const el = this.$refs.navTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
    //   const self = this
    //   this.sortable = Sortable.create(el, {
    //     animation: 150,
    //     delay: 0,
    //     handle: '.a-icon', // 句柄-点击指定class样式的对象时才能拖拽元素
    //     draggable: '.el-table__row', // 指定那些元素可以被拖拽
    //     onMove: ({dragged, related}) => {
    //       const oldRow =  self.sortTableList[dragged.rowIndex]
    //       const newRow =  self.sortTableList[related.rowIndex]
    //       if (oldRow.level !== newRow.level || oldRow.parentId !== newRow.parentId) {
    //         return false
    //       }
    //     },
    //     onEnd: ({ oldIndex, newIndex }) => {
    //       if (oldIndex === newIndex) {
    //         return
    //       }
    //       let param = { type: 1 }
    //       self.sortTableList.forEach((item, i) => {
    //         if (i === oldIndex) param = { ...param, position: item.orderNum, id: item.id }
    //         else if (i === newIndex) param = { ...param, targetPosition: item.orderNum, targetId: item.id }
    //       })

    //       API.sortProductDragOrder(param).then(res => {
    //         if (res.code !== 10000) return this.$message.error(res.message)
    //         this.getCustomNavList()
    //       })
    //     }
    //   })
    // },

    // 初始化拖拽表格
    initSortTable() {
      const el = this.$refs.navTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      const self = this
      this.sortable = createSortTable(el, this.tiledTable, (oldIndex, newIndex) => {
        let param = { type: 1 }
        self.tiledTable.forEach((item, i) => {
          if (i === oldIndex) param = { ...param, position: item.orderNum, id: item.id }
          else if (i === newIndex) param = { ...param, targetPosition: item.orderNum, targetId: item.id }
        })

        API.sortProductDragOrder(param).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.getCustomNavList()
        })
      })
    },
    
    // 自定义导航列表
    getCustomNavList(){
      this.loading = true
      if (this.$refs.navTable) {
        // 记录列表操作前位置
        this.bodyWrapperScrollTop = this.$refs.navTable.bodyWrapper.scrollTop
      }
      API.getCustomNavList(this.listForm).then(res => {
        if (this.sortable && this.sortable.el) {
          this.sortable.destroy()
        }
        this.navList = res.data
        this.setScroll()
        // 平铺树结构
        let arr = []
        const tileArr = (list) => {
          list.forEach(item => {
            arr.push(item)
            if (item.child && item.child.length) {
              return tileArr(item.child)
            }
          })
          return arr
        }
        this.tiledTable = tileArr(res.data).map((item, i) => ({ ...item, sort: i }))
        
        this.tableKey = new Date().getTime()
        this.$nextTick(() => {
          this.initSortTable()
        })
      })
    },

    // 删除
    deleteNav(row){
      this.$confirm(`是否删除该导航${(row.child && row.child.length)? '（包含子级一并删除）': ''}`,'提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
      }).then(()=>{
        API.deleteCustomNav(row.menuId).then(res=>{
          if (res.code !== 10000) return this.$message.error(res.message)
          this.getCustomNavList()
        })
      })
    },
    addNav(type, row) {
      this.$refs.navDialog.show(type, row)
    },
    openLink(row) {
      window.open((row.menuType && row.menuType === 4) ? row.linkUrl : process.env.VUE_APP_KAKACLO_URL + row.linkUrl)
    },

    // 展开指定行
    expandChange(row, expands) {
      if (expands) this.expands.push(row.id+'')
      else this.expands.splice(this.expands.indexOf(row.id+''), 1)
    },
    // 设置table位置
    setScroll() {
      this.$nextTick(()=> {
      setTimeout(() => {
        let scrollTop = this.$refs.navTable.bodyWrapper
        scrollTop.scrollTop = this.bodyWrapperScrollTop
        this.loading = false
        }, 0)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
  min-width: 1200px;
  height: 100%;
  background: #ffffff;
  padding: 12px 12px 0;

  .nav-head{
    padding-left: 10px;
    p {
      color:#8B93A3;
      font-size:12px;
    }
    div {
      padding-left: 20px;
      font-size: 16px;
      margin-bottom: 10px;
      span {
        color:#BDBDBD;
        font-size: 12px;
        margin-left: 10px;
      }
    }
  }

  .a-icon {
    display: inline-block;
    color: #afbbca;
    font-size: 20px;
    margin-right: 15px;
    cursor: move;
    user-select: none;
    &:hover {
      color: var(--PC);
    }
  }
  
  /deep/ .el-table__cell .cell {
    position: relative;
    min-height: 20px;
    display: flex;
    .sort-icon {
      width: 26px;
      position: absolute;
    }
  }

  /deep/ .el-tag{
    height: 24px;
    line-height: 22px;
    padding: 0 6px;
  }
}
</style>
